/* eslint-disable max-len */
/* eslint-disable no-else-return */
/* eslint-disable array-callback-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-restricted-globals */

export default (editor, opts = {}) => {
  const dc = editor.DomComponents;
  const defaultType = dc.getType('default');
  const defaultView = defaultType.view;

  function handleButtonClickOpenCustomSumManager(model) {
    const {handleModalSumInfo} = opts;
    handleModalSumInfo(
      model,
    );
  }

  function buttonToHandleSumData(model) {
    const traitCustomSumHandler = {
      name: 'buttonManageSumData',
      type: 'button',
      text: 'Manejar Operaciones',
      full: true,
      command: () => handleButtonClickOpenCustomSumManager(
        model,
      ),
    };
    model.addTrait(traitCustomSumHandler);
  }

  dc.addType(opts.name, {
    model: {
      defaults: {
        traits: [],
      },
    },

    // eslint-disable-next-line consistent-return
    isComponent: (el) => {
      try {
        const attr = el.attributes;
        if (attr['data-gjs-sluglofty'] && attr['data-gjs-sluglofty'].value.includes('sumdataContainer')) {
          return {
            type: opts.name,
          };
        }
      } catch (error) {
        // console.log(error);
      }
    },

    view: defaultView.extend({
      init({model}) {
        this.listenTo(model, '', this.restoreData());
      },
      restoreData() {
        if (this.model.attributes.sluglofty.includes('sumdataContainer')) {
          this.model.removeTrait('buttonManageSumData');
          buttonToHandleSumData(this.model);
        }
      },
    }),
  });
};
